import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Container, Navbar, Row, Col } from "shards-react";

// import NavbarSearch from "./NavbarSearch";
// import NavbarNav from "./NavbarNav/NavbarNav";
// import NavbarToggle from "./NavbarToggle";

const MainNavbar = ({ layout, stickyTop }) => {
  const classes = classNames(
    "main-navbar",
    "bg-white",
    stickyTop && "sticky-top"
  );

  return (
    <div className={classes}>
      <Container>
        <Row>
          <Col className="d-flex align-items-center justify-content-center pt-2 pb-2">
            <img src="https://xetnghiemtaman.com/logo2.png" height="50" width="50" />
            <span className="text-danger text-nowrap font-weight-bold ml-1" style={{fontSize: '1.3rem'}}>TÂM AN</span>
          </Col>
        </Row>
        {/* <Navbar type="light" className="align-items-stretch flex-md-nowrap p-0">
          <NavbarSearch />
          <NavbarNav />
          <NavbarToggle />
        </Navbar> */}
      </Container>
    </div>
  );
};

MainNavbar.propTypes = {
  /**
   * The layout type where the MainNavbar is used.
   */
  layout: PropTypes.string,
  /**
   * Whether the main navbar is sticky to the top, or not.
   */
  stickyTop: PropTypes.bool
};

MainNavbar.defaultProps = {
  stickyTop: true
};

export default MainNavbar;
